import { SVGProps } from 'react'

export const RemixIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={15}
    viewBox="0 0 40 40"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.707 27.593c.252 3.235.252 4.752.252 6.407h-7.49c0-.36.006-.69.012-1.025.02-1.04.042-2.124-.127-4.313-.223-3.206-1.604-3.918-4.144-3.918H8.428V18.91h12.138c3.209 0 4.813-.975 4.813-3.557 0-2.27-1.604-3.647-4.813-3.647H8.428V6h13.475c7.264 0 10.873 3.428 10.873 8.904 0 4.096-2.54 6.768-5.971 7.213 2.896.579 4.59 2.226 4.902 5.476Z"
      fill="currentColor"
    />
    <path
      d="M8.428 34v-4.348h7.92c1.324 0 1.611.98 1.611 1.565V34h-9.53Z"
      fill="currentColor"
    />
  </svg>
)
